/** CoStar.Api.FusionSearch.Criteria.CompSource */
export var CompSource;
(function (CompSource) {
    CompSource[CompSource["Unknown"] = 0] = "Unknown";
    CompSource[CompSource["Default"] = 1] = "Default";
    CompSource[CompSource["Collaboration"] = 2] = "Collaboration";
})(CompSource || (CompSource = {}));
/** CoStar.Api.FusionSearch.Criteria.Exclusivity */
export var Exclusivity;
(function (Exclusivity) {
    Exclusivity[Exclusivity["IncludeOnly"] = 0] = "IncludeOnly";
    Exclusivity[Exclusivity["ExcludeAll"] = 1] = "ExcludeAll";
})(Exclusivity || (Exclusivity = {}));
/** CoStar.Api.FusionSearch.Criteria.BedroomType */
export var BedroomType;
(function (BedroomType) {
    BedroomType[BedroomType["All"] = 0] = "All";
    BedroomType[BedroomType["Studio"] = 1] = "Studio";
    BedroomType[BedroomType["One"] = 2] = "One";
    BedroomType[BedroomType["Two"] = 3] = "Two";
    BedroomType[BedroomType["Three"] = 4] = "Three";
    BedroomType[BedroomType["FourOrMore"] = 5] = "FourOrMore";
})(BedroomType || (BedroomType = {}));
/** CoStar.Api.FusionSearch.Criteria.AssetType */
export var AssetType;
(function (AssetType) {
    AssetType[AssetType["None"] = 0] = "None";
    AssetType[AssetType["Property"] = 1] = "Property";
    AssetType[AssetType["Loan"] = 2] = "Loan";
})(AssetType || (AssetType = {}));
/** CoStar.Api.FusionSearch.Criteria.Region */
export var Region;
(function (Region) {
    Region[Region["None"] = 0] = "None";
    Region[Region["NorthEast"] = 303] = "NorthEast";
    Region[Region["MidWest"] = 304] = "MidWest";
    Region[Region["South"] = 305] = "South";
    Region[Region["West"] = 306] = "West";
})(Region || (Region = {}));
/** CoStar.Api.FusionSearch.Criteria.TravelMode */
export var TravelMode;
(function (TravelMode) {
    TravelMode[TravelMode["Drive"] = 0] = "Drive";
    TravelMode[TravelMode["Transit"] = 1] = "Transit";
    TravelMode[TravelMode["Walk"] = 2] = "Walk";
    TravelMode[TravelMode["Bike"] = 3] = "Bike";
})(TravelMode || (TravelMode = {}));
/** CoStar.Api.FusionSearch.Criteria.TravelCondition */
export var TravelCondition;
(function (TravelCondition) {
    TravelCondition[TravelCondition["NoTraffic"] = 0] = "NoTraffic";
    TravelCondition[TravelCondition["RushHour"] = 1] = "RushHour";
})(TravelCondition || (TravelCondition = {}));
/** CoStar.Api.FusionSearch.Criteria.ListMatchType */
export var ListMatchType;
(function (ListMatchType) {
    ListMatchType[ListMatchType["MatchAny"] = 0] = "MatchAny";
    ListMatchType[ListMatchType["MatchAll"] = 1] = "MatchAll";
})(ListMatchType || (ListMatchType = {}));
/** CoStar.Api.FusionSearch.Criteria.RateBasisType */
export var RateBasisType;
(function (RateBasisType) {
    RateBasisType[RateBasisType["Default"] = 0] = "Default";
    RateBasisType[RateBasisType["Monthly"] = 1] = "Monthly";
    RateBasisType[RateBasisType["Yearly"] = 2] = "Yearly";
})(RateBasisType || (RateBasisType = {}));
/** CoStar.Api.FusionSearch.Criteria.IncludeOrExcludeType */
export var IncludeOrExcludeType;
(function (IncludeOrExcludeType) {
    IncludeOrExcludeType[IncludeOrExcludeType["Include"] = 0] = "Include";
    IncludeOrExcludeType[IncludeOrExcludeType["Exclude"] = 1] = "Exclude";
})(IncludeOrExcludeType || (IncludeOrExcludeType = {}));
/** CoStar.Api.FusionSearch.Criteria.SaleStatus */
export var SaleStatus;
(function (SaleStatus) {
    SaleStatus[SaleStatus["None"] = 0] = "None";
    SaleStatus[SaleStatus["Active"] = 1] = "Active";
    SaleStatus[SaleStatus["Escrow"] = 2] = "Escrow";
    SaleStatus[SaleStatus["Pending"] = 3] = "Pending";
    SaleStatus[SaleStatus["UnderContract"] = 4] = "UnderContract";
    SaleStatus[SaleStatus["Sold"] = 5] = "Sold";
})(SaleStatus || (SaleStatus = {}));
/** CoStar.Api.FusionSearch.Criteria.FundTransactionType */
export var FundTransactionType;
(function (FundTransactionType) {
    FundTransactionType[FundTransactionType["None"] = 0] = "None";
    FundTransactionType[FundTransactionType["Acquisition"] = 1] = "Acquisition";
    FundTransactionType[FundTransactionType["Disposition"] = 2] = "Disposition";
})(FundTransactionType || (FundTransactionType = {}));
/** CoStar.Api.FusionSearch.Criteria.Source */
export var Source;
(function (Source) {
    Source[Source["CoStarPublished"] = 0] = "CoStarPublished";
    Source[Source["PublicRecord"] = 1] = "PublicRecord";
})(Source || (Source = {}));
/** CoStar.Api.FusionSearch.Criteria.OriginType */
export var OriginType;
(function (OriginType) {
    OriginType[OriginType["Local"] = 1] = "Local";
    OriginType[OriginType["National"] = 2] = "National";
    OriginType[OriginType["Foreign"] = 3] = "Foreign";
})(OriginType || (OriginType = {}));
/** CoStar.Api.FusionSearch.Criteria.InvestmentType */
export var InvestmentType;
(function (InvestmentType) {
    InvestmentType[InvestmentType["None"] = 0] = "None";
    InvestmentType[InvestmentType["Core"] = 1] = "Core";
    InvestmentType[InvestmentType["ValueAdd"] = 2] = "ValueAdd";
    InvestmentType[InvestmentType["Opportunistic"] = 4] = "Opportunistic";
    InvestmentType[InvestmentType["NNN"] = 8] = "NNN";
    InvestmentType[InvestmentType["PropertyLoanForAuction"] = 16] = "PropertyLoanForAuction";
})(InvestmentType || (InvestmentType = {}));
/** CoStar.Api.FusionSearch.Criteria.InterestOnlyType */
export var InterestOnlyType;
(function (InterestOnlyType) {
    InterestOnlyType[InterestOnlyType["None"] = 0] = "None";
    InterestOnlyType[InterestOnlyType["Partial"] = 1] = "Partial";
    InterestOnlyType[InterestOnlyType["Full"] = 2] = "Full";
})(InterestOnlyType || (InterestOnlyType = {}));
/** CoStar.Api.FusionSearch.Criteria.InterestRateType */
export var InterestRateType;
(function (InterestRateType) {
    InterestRateType[InterestRateType["None"] = 0] = "None";
    InterestRateType[InterestRateType["Fixed"] = 1] = "Fixed";
    InterestRateType[InterestRateType["Variable"] = 2] = "Variable";
})(InterestRateType || (InterestRateType = {}));
/** CoStar.Api.FusionSearch.Criteria.LoanPaymentStatus */
export var LoanPaymentStatus;
(function (LoanPaymentStatus) {
    LoanPaymentStatus[LoanPaymentStatus["None"] = 0] = "None";
    LoanPaymentStatus[LoanPaymentStatus["Performing"] = 1] = "Performing";
    LoanPaymentStatus[LoanPaymentStatus["ThirtyDaysDelinquent"] = 2] = "ThirtyDaysDelinquent";
    LoanPaymentStatus[LoanPaymentStatus["SixtyDaysDelinquent"] = 3] = "SixtyDaysDelinquent";
    LoanPaymentStatus[LoanPaymentStatus["NinetyPlusDaysDelinquent"] = 4] = "NinetyPlusDaysDelinquent";
    LoanPaymentStatus[LoanPaymentStatus["MaturityDefault"] = 5] = "MaturityDefault";
    LoanPaymentStatus[LoanPaymentStatus["Foreclosed"] = 6] = "Foreclosed";
    LoanPaymentStatus[LoanPaymentStatus["Defeased"] = 7] = "Defeased";
    LoanPaymentStatus[LoanPaymentStatus["Bankrupt"] = 8] = "Bankrupt";
    LoanPaymentStatus[LoanPaymentStatus["RealEstateOwned"] = 9] = "RealEstateOwned";
})(LoanPaymentStatus || (LoanPaymentStatus = {}));
/** CoStar.Api.FusionSearch.Criteria.LoanPrepaymentPeriodType */
export var LoanPrepaymentPeriodType;
(function (LoanPrepaymentPeriodType) {
    LoanPrepaymentPeriodType[LoanPrepaymentPeriodType["None"] = 0] = "None";
    LoanPrepaymentPeriodType[LoanPrepaymentPeriodType["Lockout"] = 1] = "Lockout";
    LoanPrepaymentPeriodType[LoanPrepaymentPeriodType["YieldMaintenance"] = 2] = "YieldMaintenance";
    LoanPrepaymentPeriodType[LoanPrepaymentPeriodType["Defeasible"] = 3] = "Defeasible";
    LoanPrepaymentPeriodType[LoanPrepaymentPeriodType["Premium"] = 4] = "Premium";
    LoanPrepaymentPeriodType[LoanPrepaymentPeriodType["Open"] = 5] = "Open";
})(LoanPrepaymentPeriodType || (LoanPrepaymentPeriodType = {}));
/** CoStar.Api.FusionSearch.Criteria.SpecialServicingStatus */
export var SpecialServicingStatus;
(function (SpecialServicingStatus) {
    SpecialServicingStatus[SpecialServicingStatus["None"] = 0] = "None";
    SpecialServicingStatus[SpecialServicingStatus["Current"] = 1] = "Current";
    SpecialServicingStatus[SpecialServicingStatus["Previous"] = 2] = "Previous";
    SpecialServicingStatus[SpecialServicingStatus["Never"] = 3] = "Never";
})(SpecialServicingStatus || (SpecialServicingStatus = {}));
/** CoStar.Api.FusionSearch.Criteria.LoanStatus */
export var LoanStatus;
(function (LoanStatus) {
    LoanStatus[LoanStatus["None"] = 0] = "None";
    LoanStatus[LoanStatus["Active"] = 1] = "Active";
    LoanStatus[LoanStatus["Disposed"] = 2] = "Disposed";
})(LoanStatus || (LoanStatus = {}));
/** CoStar.Api.FusionSearch.Criteria.WatchlistStatus */
export var WatchlistStatus;
(function (WatchlistStatus) {
    WatchlistStatus[WatchlistStatus["None"] = 0] = "None";
    WatchlistStatus[WatchlistStatus["Current"] = 1] = "Current";
    WatchlistStatus[WatchlistStatus["Previous"] = 2] = "Previous";
    WatchlistStatus[WatchlistStatus["Never"] = 3] = "Never";
})(WatchlistStatus || (WatchlistStatus = {}));
/** CoStar.Api.FusionSearch.Criteria.FundStatus */
export var FundStatus;
(function (FundStatus) {
    FundStatus[FundStatus["None"] = 0] = "None";
    FundStatus[FundStatus["Closed"] = 1] = "Closed";
    FundStatus[FundStatus["Liquidated"] = 2] = "Liquidated";
    FundStatus[FundStatus["OpenEnded"] = 3] = "OpenEnded";
    FundStatus[FundStatus["AnnouncedEstimated"] = 4] = "AnnouncedEstimated";
    FundStatus[FundStatus["SemiOpenEnded"] = 5] = "SemiOpenEnded";
    FundStatus[FundStatus["Evergreen"] = 6] = "Evergreen";
    FundStatus[FundStatus["Raising"] = 7] = "Raising";
    FundStatus[FundStatus["Listed"] = 8] = "Listed";
    FundStatus[FundStatus["FirstClose"] = 9] = "FirstClose";
    FundStatus[FundStatus["SecondClose"] = 10] = "SecondClose";
    FundStatus[FundStatus["ThirdClose"] = 11] = "ThirdClose";
    FundStatus[FundStatus["ForthClose"] = 12] = "ForthClose";
    FundStatus[FundStatus["FifthClose"] = 13] = "FifthClose";
    FundStatus[FundStatus["SixthClose"] = 14] = "SixthClose";
})(FundStatus || (FundStatus = {}));
/** CoStar.Api.FusionSearch.Criteria.FundStrategy */
export var FundStrategy;
(function (FundStrategy) {
    FundStrategy[FundStrategy["None"] = 0] = "None";
    FundStrategy[FundStrategy["ValueAdded"] = 1] = "ValueAdded";
    FundStrategy[FundStrategy["Opportunistic"] = 2] = "Opportunistic";
    FundStrategy[FundStrategy["Core"] = 3] = "Core";
    FundStrategy[FundStrategy["Debt"] = 4] = "Debt";
    FundStrategy[FundStrategy["CorePlus"] = 5] = "CorePlus";
    FundStrategy[FundStrategy["FundOfFunds"] = 6] = "FundOfFunds";
    FundStrategy[FundStrategy["RealEstate"] = 7] = "RealEstate";
    FundStrategy[FundStrategy["Distressed"] = 8] = "Distressed";
    FundStrategy[FundStrategy["CoInvestment"] = 9] = "CoInvestment";
    FundStrategy[FundStrategy["Secondaries"] = 10] = "Secondaries";
})(FundStrategy || (FundStrategy = {}));
/** CoStar.Api.FusionSearch.Criteria.FundStructure */
export var FundStructure;
(function (FundStructure) {
    FundStructure[FundStructure["None"] = 0] = "None";
    FundStructure[FundStructure["Commingled"] = 1] = "Commingled";
    FundStructure[FundStructure["SeparatelyManagedAccount"] = 2] = "SeparatelyManagedAccount";
})(FundStructure || (FundStructure = {}));
/** CoStar.Api.FusionSearch.Criteria.FloodPlain */
export var FloodPlain;
(function (FloodPlain) {
    FloodPlain[FloodPlain["None"] = 0] = "None";
    FloodPlain[FloodPlain["FiveHundredYear"] = 2] = "FiveHundredYear";
    FloodPlain[FloodPlain["HundredYear"] = 3] = "HundredYear";
})(FloodPlain || (FloodPlain = {}));
/** CoStar.Api.FusionSearch.Criteria.FloodRiskArea */
export var FloodRiskArea;
(function (FloodRiskArea) {
    FloodRiskArea[FloodRiskArea["None"] = 0] = "None";
    FloodRiskArea[FloodRiskArea["ModerateToLow"] = 1] = "ModerateToLow";
    FloodRiskArea[FloodRiskArea["HighRisk"] = 3] = "HighRisk";
    FloodRiskArea[FloodRiskArea["HighRiskCoastal"] = 10] = "HighRiskCoastal";
    FloodRiskArea[FloodRiskArea["Undetermined"] = 12] = "Undetermined";
})(FloodRiskArea || (FloodRiskArea = {}));
/** CoStar.Api.FusionSearch.Criteria.FloodZone */
export var FloodZone;
(function (FloodZone) {
    FloodZone[FloodZone["None"] = 0] = "None";
    FloodZone[FloodZone["BandXShaded"] = 1] = "BandXShaded";
    FloodZone[FloodZone["CandXUnshaded"] = 2] = "CandXUnshaded";
    FloodZone[FloodZone["A"] = 3] = "A";
    FloodZone[FloodZone["AE"] = 4] = "AE";
    FloodZone[FloodZone["A1to30"] = 5] = "A1to30";
    FloodZone[FloodZone["AH"] = 6] = "AH";
    FloodZone[FloodZone["AO"] = 7] = "AO";
    FloodZone[FloodZone["AR"] = 8] = "AR";
    FloodZone[FloodZone["A99"] = 9] = "A99";
    FloodZone[FloodZone["V"] = 10] = "V";
    FloodZone[FloodZone["VEorV1to30"] = 11] = "VEorV1to30";
    FloodZone[FloodZone["D"] = 12] = "D";
})(FloodZone || (FloodZone = {}));
/** CoStar.Api.FusionSearch.Criteria.DemographicDataGroup */
export var DemographicDataGroup;
(function (DemographicDataGroup) {
    DemographicDataGroup[DemographicDataGroup["None"] = 0] = "None";
    DemographicDataGroup[DemographicDataGroup["Primary"] = 1] = "Primary";
    DemographicDataGroup[DemographicDataGroup["Secondary"] = 2] = "Secondary";
    DemographicDataGroup[DemographicDataGroup["Tertiary"] = 3] = "Tertiary";
})(DemographicDataGroup || (DemographicDataGroup = {}));
/** CoStar.Api.FusionSearch.Criteria.DemographicRadiusIndex */
export var DemographicRadiusIndex;
(function (DemographicRadiusIndex) {
    DemographicRadiusIndex[DemographicRadiusIndex["None"] = 0] = "None";
    DemographicRadiusIndex[DemographicRadiusIndex["OneMile"] = 1] = "OneMile";
    DemographicRadiusIndex[DemographicRadiusIndex["TwoMile"] = 2] = "TwoMile";
    DemographicRadiusIndex[DemographicRadiusIndex["ThreeMile"] = 3] = "ThreeMile";
    DemographicRadiusIndex[DemographicRadiusIndex["FiveMile"] = 4] = "FiveMile";
    DemographicRadiusIndex[DemographicRadiusIndex["TenMile"] = 5] = "TenMile";
})(DemographicRadiusIndex || (DemographicRadiusIndex = {}));
/** CoStar.Api.FusionSearch.Criteria.DemographicTableSource */
export var DemographicTableSource;
(function (DemographicTableSource) {
    DemographicTableSource[DemographicTableSource["None"] = 0] = "None";
    DemographicTableSource[DemographicTableSource["ConsumerSpending"] = 1] = "ConsumerSpending";
    DemographicTableSource[DemographicTableSource["DaytimeEmployment"] = 2] = "DaytimeEmployment";
    DemographicTableSource[DemographicTableSource["PopFacts"] = 3] = "PopFacts";
})(DemographicTableSource || (DemographicTableSource = {}));
/** CoStar.Api.FusionSearch.Criteria.EnergyCertification */
export var EnergyCertification;
(function (EnergyCertification) {
    EnergyCertification[EnergyCertification["None"] = 0] = "None";
    EnergyCertification[EnergyCertification["EnergyStar"] = 1] = "EnergyStar";
    EnergyCertification[EnergyCertification["Leed"] = 2] = "Leed";
    EnergyCertification[EnergyCertification["BreeamPass"] = 10] = "BreeamPass";
    EnergyCertification[EnergyCertification["BreeamGood"] = 11] = "BreeamGood";
    EnergyCertification[EnergyCertification["BreeamVeryGood"] = 12] = "BreeamVeryGood";
    EnergyCertification[EnergyCertification["BreeamExcellent"] = 13] = "BreeamExcellent";
    EnergyCertification[EnergyCertification["BreeamOutstanding"] = 14] = "BreeamOutstanding";
})(EnergyCertification || (EnergyCertification = {}));
/** CoStar.Api.FusionSearch.Criteria.LeedCertificationType */
export var LeedCertificationType;
(function (LeedCertificationType) {
    LeedCertificationType[LeedCertificationType["None"] = 0] = "None";
    LeedCertificationType[LeedCertificationType["LeedCertified"] = 1] = "LeedCertified";
    LeedCertificationType[LeedCertificationType["LeedCertifiedGold"] = 2] = "LeedCertifiedGold";
    LeedCertificationType[LeedCertificationType["LeedCertifiedPlatinum"] = 3] = "LeedCertifiedPlatinum";
    LeedCertificationType[LeedCertificationType["LeedCertifiedSilver"] = 4] = "LeedCertifiedSilver";
})(LeedCertificationType || (LeedCertificationType = {}));
/** CoStar.Api.FusionSearch.Criteria.Tenancy */
export var Tenancy;
(function (Tenancy) {
    Tenancy[Tenancy["Unknown"] = 0] = "Unknown";
    Tenancy[Tenancy["Single"] = 1] = "Single";
    Tenancy[Tenancy["Multiple"] = 2] = "Multiple";
})(Tenancy || (Tenancy = {}));
/** CoStar.Api.FusionSearch.Criteria.ShapeType */
export var ShapeType;
(function (ShapeType) {
    ShapeType[ShapeType["Unknown"] = 0] = "Unknown";
    ShapeType[ShapeType["TravelTime"] = 1] = "TravelTime";
})(ShapeType || (ShapeType = {}));
/** CoStar.Api.FusionSearch.Criteria.CombinationType */
export var CombinationType;
(function (CombinationType) {
    CombinationType[CombinationType["Union"] = 0] = "Union";
    CombinationType[CombinationType["Intersection"] = 1] = "Intersection";
})(CombinationType || (CombinationType = {}));
/** CoStar.Api.FusionSearch.Criteria.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["None"] = 0] = "None";
    ListingType[ListingType["ForLease"] = 1] = "ForLease";
    ListingType[ListingType["ForSale"] = 2] = "ForSale";
    ListingType[ListingType["ForLeaseAndForSale"] = 3] = "ForLeaseAndForSale";
})(ListingType || (ListingType = {}));
/** CoStar.Api.FusionSearch.Criteria.LeaseDealOriginType */
export var LeaseDealOriginType;
(function (LeaseDealOriginType) {
    LeaseDealOriginType[LeaseDealOriginType["Unknown"] = 0] = "Unknown";
    LeaseDealOriginType[LeaseDealOriginType["CoStar"] = 1] = "CoStar";
    LeaseDealOriginType[LeaseDealOriginType["LeaseAnalysis"] = 2] = "LeaseAnalysis";
    LeaseDealOriginType[LeaseDealOriginType["SharedData"] = 3] = "SharedData";
    LeaseDealOriginType[LeaseDealOriginType["MyData"] = 4] = "MyData";
})(LeaseDealOriginType || (LeaseDealOriginType = {}));
/** CoStar.Api.FusionSearch.Criteria.BusinessType */
export var BusinessType;
(function (BusinessType) {
    BusinessType[BusinessType["None"] = 0] = "None";
    BusinessType[BusinessType["CorporateUserNonRetail"] = 1] = "CorporateUserNonRetail";
    BusinessType[BusinessType["ResidentialDevelopers"] = 2] = "ResidentialDevelopers";
    BusinessType[BusinessType["EducationUniv"] = 3] = "EducationUniv";
    BusinessType[BusinessType["Government"] = 4] = "Government";
    BusinessType[BusinessType["InstitutionalInvestor"] = 5] = "InstitutionalInvestor";
    BusinessType[BusinessType["Internal"] = 6] = "Internal";
    BusinessType[BusinessType["Owner"] = 7] = "Owner";
    BusinessType[BusinessType["Lender"] = 8] = "Lender";
    BusinessType[BusinessType["PropertyManagement"] = 9] = "PropertyManagement";
    BusinessType[BusinessType["PublicRelations"] = 10] = "PublicRelations";
    BusinessType[BusinessType["TaxAppeal"] = 11] = "TaxAppeal";
    BusinessType[BusinessType["TradeGroupsNonProfitAssociations"] = 12] = "TradeGroupsNonProfitAssociations";
    BusinessType[BusinessType["BuildingServicesVendors"] = 13] = "BuildingServicesVendors";
    BusinessType[BusinessType["AppraisalValuation"] = 14] = "AppraisalValuation";
    BusinessType[BusinessType["BrokerageCommercial"] = 15] = "BrokerageCommercial";
    BusinessType[BusinessType["AssociationsTradeEducation"] = 16] = "AssociationsTradeEducation";
    BusinessType[BusinessType["Telecommunications"] = 17] = "Telecommunications";
    BusinessType[BusinessType["Architect"] = 18] = "Architect";
    BusinessType[BusinessType["Consultants"] = 19] = "Consultants";
    BusinessType[BusinessType["MortgageBrokersFinance"] = 20] = "MortgageBrokersFinance";
    BusinessType[BusinessType["Media"] = 21] = "Media";
    BusinessType[BusinessType["Retailer"] = 22] = "Retailer";
    BusinessType[BusinessType["BrokerageResidential"] = 23] = "BrokerageResidential";
    BusinessType[BusinessType["BrokerageResimercial"] = 24] = "BrokerageResimercial";
    BusinessType[BusinessType["ConstructionCompanies"] = 25] = "ConstructionCompanies";
    BusinessType[BusinessType["ExecutiveSuites"] = 26] = "ExecutiveSuites";
    BusinessType[BusinessType["Hotels"] = 27] = "Hotels";
    BusinessType[BusinessType["ProfessionalServices"] = 28] = "ProfessionalServices";
    BusinessType[BusinessType["Utilities"] = 29] = "Utilities";
    BusinessType[BusinessType["TitleCompany"] = 30] = "TitleCompany";
    BusinessType[BusinessType["Operator"] = 31] = "Operator";
    BusinessType[BusinessType["Academia"] = 32] = "Academia";
    BusinessType[BusinessType["Destination"] = 33] = "Destination";
})(BusinessType || (BusinessType = {}));
/** CoStar.Api.FusionSearch.Criteria.CreditRating */
export var CreditRating;
(function (CreditRating) {
    CreditRating[CreditRating["None"] = 0] = "None";
    CreditRating[CreditRating["VeryLowRisk"] = 1] = "VeryLowRisk";
    CreditRating[CreditRating["LowRisk"] = 2] = "LowRisk";
    CreditRating[CreditRating["ModerateRisk"] = 3] = "ModerateRisk";
    CreditRating[CreditRating["HighRisk"] = 4] = "HighRisk";
    CreditRating[CreditRating["VeryHighRisk"] = 5] = "VeryHighRisk";
})(CreditRating || (CreditRating = {}));
/** CoStar.Api.FusionSearch.Criteria.MoveType */
export var MoveType;
(function (MoveType) {
    MoveType[MoveType["MovingIn"] = 1] = "MovingIn";
    MoveType[MoveType["MovingInBuilding"] = 2] = "MovingInBuilding";
    MoveType[MoveType["MovingOut"] = 3] = "MovingOut";
})(MoveType || (MoveType = {}));
/** CoStar.Api.FusionSearch.Criteria.TenantInsight */
export var TenantInsight;
(function (TenantInsight) {
    TenantInsight[TenantInsight["None"] = 0] = "None";
    TenantInsight[TenantInsight["UpcomingLeaseExpiration"] = 1] = "UpcomingLeaseExpiration";
    TenantInsight[TenantInsight["TenantInNonContiguousSuites"] = 2] = "TenantInNonContiguousSuites";
    TenantInsight[TenantInsight["TenantInMultipleBuildingsInPark"] = 3] = "TenantInMultipleBuildingsInPark";
    TenantInsight[TenantInsight["TenantInMultipleLocationsInMarket"] = 4] = "TenantInMultipleLocationsInMarket";
    TenantInsight[TenantInsight["BuildingForSale"] = 5] = "BuildingForSale";
    TenantInsight[TenantInsight["BuildingRecentlySold"] = 6] = "BuildingRecentlySold";
    TenantInsight[TenantInsight["BuildingLoanStatus"] = 7] = "BuildingLoanStatus";
    TenantInsight[TenantInsight["UpcomingLoanMaturity"] = 8] = "UpcomingLoanMaturity";
    TenantInsight[TenantInsight["LoanMaturityAroundTerminationOption"] = 9] = "LoanMaturityAroundTerminationOption";
    TenantInsight[TenantInsight["LoanMaturityAroundLeaseExpiration"] = 10] = "LoanMaturityAroundLeaseExpiration";
    TenantInsight[TenantInsight["MovingInTenants"] = 11] = "MovingInTenants";
    TenantInsight[TenantInsight["MovingOutTenants"] = 12] = "MovingOutTenants";
    TenantInsight[TenantInsight["BusinessParkVacancy"] = 13] = "BusinessParkVacancy";
    TenantInsight[TenantInsight["OngoingBuildingRenovations"] = 14] = "OngoingBuildingRenovations";
    TenantInsight[TenantInsight["RecentBuildingRenovations"] = 15] = "RecentBuildingRenovations";
    TenantInsight[TenantInsight["NewPropetyManagement"] = 16] = "NewPropetyManagement";
})(TenantInsight || (TenantInsight = {}));
/** CoStar.Api.FusionSearch.Criteria.OccupancyType */
export var OccupancyType;
(function (OccupancyType) {
    OccupancyType[OccupancyType["Leased"] = 1] = "Leased";
    OccupancyType[OccupancyType["Subleased"] = 2] = "Subleased";
    OccupancyType[OccupancyType["Owned"] = 3] = "Owned";
    OccupancyType[OccupancyType["Assignment"] = 4] = "Assignment";
    OccupancyType[OccupancyType["Coworking"] = 5] = "Coworking";
    OccupancyType[OccupancyType["Unknown"] = 6] = "Unknown";
})(OccupancyType || (OccupancyType = {}));
/** CoStar.Api.FusionSearch.Criteria.StoreType */
export var StoreType;
(function (StoreType) {
    StoreType[StoreType["None"] = 0] = "None";
    StoreType[StoreType["EmploymentAgency"] = 1] = "EmploymentAgency";
    StoreType[StoreType["Bagel"] = 2] = "Bagel";
    StoreType[StoreType["Fitness"] = 3] = "Fitness";
    StoreType[StoreType["AutoShowroom"] = 4] = "AutoShowroom";
    StoreType[StoreType["FilmProcessing"] = 5] = "FilmProcessing";
    StoreType[StoreType["SpecialtyFoods"] = 6] = "SpecialtyFoods";
    StoreType[StoreType["CardGifts"] = 7] = "CardGifts";
    StoreType[StoreType["OtherRetail"] = 9] = "OtherRetail";
    StoreType[StoreType["IceCream"] = 10] = "IceCream";
    StoreType[StoreType["Books"] = 11] = "Books";
    StoreType[StoreType["OtherServices"] = 13] = "OtherServices";
    StoreType[StoreType["CandyNuts"] = 14] = "CandyNuts";
    StoreType[StoreType["ConsumerElectronics"] = 16] = "ConsumerElectronics";
    StoreType[StoreType["FloorCovering"] = 17] = "FloorCovering";
    StoreType[StoreType["MusicInstruments"] = 18] = "MusicInstruments";
    StoreType[StoreType["LeatherLuggagePurses"] = 19] = "LeatherLuggagePurses";
    StoreType[StoreType["Tobacco"] = 20] = "Tobacco";
    StoreType[StoreType["Automotive"] = 21] = "Automotive";
    StoreType[StoreType["GasolineStation"] = 22] = "GasolineStation";
    StoreType[StoreType["NailSalon"] = 23] = "NailSalon";
    StoreType[StoreType["SalonBarberSpa"] = 24] = "SalonBarberSpa";
    StoreType[StoreType["ChildrenApparel"] = 25] = "ChildrenApparel";
    StoreType[StoreType["CocktailBar"] = 26] = "CocktailBar";
    StoreType[StoreType["TravelAgent"] = 27] = "TravelAgent";
    StoreType[StoreType["HomeImprovement"] = 28] = "HomeImprovement";
    StoreType[StoreType["ChinaGlass"] = 29] = "ChinaGlass";
    StoreType[StoreType["Coffee"] = 30] = "Coffee";
    StoreType[StoreType["Bakery"] = 31] = "Bakery";
    StoreType[StoreType["Laundry"] = 32] = "Laundry";
    StoreType[StoreType["WindowCoverings"] = 33] = "WindowCoverings";
    StoreType[StoreType["ArtCrafts"] = 35] = "ArtCrafts";
    StoreType[StoreType["Supermarket"] = 36] = "Supermarket";
    StoreType[StoreType["MDDDS"] = 37] = "MDDDS";
    StoreType[StoreType["Florist"] = 38] = "Florist";
    StoreType[StoreType["KeyShop"] = 39] = "KeyShop";
    StoreType[StoreType["DeptStore"] = 40] = "DeptStore";
    StoreType[StoreType["OffPrice"] = 41] = "OffPrice";
    StoreType[StoreType["LadiesApparel"] = 42] = "LadiesApparel";
    StoreType[StoreType["Bank"] = 43] = "Bank";
    StoreType[StoreType["ArtGallery"] = 44] = "ArtGallery";
    StoreType[StoreType["OfficeSupply"] = 45] = "OfficeSupply";
    StoreType[StoreType["DrugStore"] = 46] = "DrugStore";
    StoreType[StoreType["LampsLighting"] = 47] = "LampsLighting";
    StoreType[StoreType["GameStore"] = 48] = "GameStore";
    StoreType[StoreType["Shoes"] = 49] = "Shoes";
    StoreType[StoreType["BowlingBilliards"] = 50] = "BowlingBilliards";
    StoreType[StoreType["Hardware"] = 52] = "Hardware";
    StoreType[StoreType["InvestmentService"] = 53] = "InvestmentService";
    StoreType[StoreType["AcctgTaxPrep"] = 56] = "AcctgTaxPrep";
    StoreType[StoreType["Fastfood"] = 57] = "Fastfood";
    StoreType[StoreType["HealthFood"] = 58] = "HealthFood";
    StoreType[StoreType["WirelessCommunications"] = 60] = "WirelessCommunications";
    StoreType[StoreType["Imports"] = 61] = "Imports";
    StoreType[StoreType["Newsstand"] = 62] = "Newsstand";
    StoreType[StoreType["Arcade"] = 63] = "Arcade";
    StoreType[StoreType["PetShopSupplies"] = 64] = "PetShopSupplies";
    StoreType[StoreType["FabricShop"] = 65] = "FabricShop";
    StoreType[StoreType["UnisexApparel"] = 66] = "UnisexApparel";
    StoreType[StoreType["FormalWear"] = 70] = "FormalWear";
    StoreType[StoreType["DiscountStore"] = 71] = "DiscountStore";
    StoreType[StoreType["Cinema"] = 72] = "Cinema";
    StoreType[StoreType["Accessory"] = 73] = "Accessory";
    StoreType[StoreType["Cafeteria"] = 74] = "Cafeteria";
    StoreType[StoreType["PaintWallpaper"] = 75] = "PaintWallpaper";
    StoreType[StoreType["WholesaleClub"] = 76] = "WholesaleClub";
    StoreType[StoreType["BikeShop"] = 77] = "BikeShop";
    StoreType[StoreType["FurnitureMattress"] = 78] = "FurnitureMattress";
    StoreType[StoreType["Toys"] = 79] = "Toys";
    StoreType[StoreType["HomeAccessories"] = 80] = "HomeAccessories";
    StoreType[StoreType["Photographer"] = 81] = "Photographer";
    StoreType[StoreType["ChurchCommHall"] = 83] = "ChurchCommHall";
    StoreType[StoreType["ConvenienceMarket"] = 84] = "ConvenienceMarket";
    StoreType[StoreType["OtherOffice"] = 86] = "OtherOffice";
    StoreType[StoreType["DonutShop"] = 87] = "DonutShop";
    StoreType[StoreType["Liquor"] = 88] = "Liquor";
    StoreType[StoreType["VideoGamesRental"] = 89] = "VideoGamesRental";
    StoreType[StoreType["Stationery"] = 90] = "Stationery";
    StoreType[StoreType["Insurance"] = 91] = "Insurance";
    StoreType[StoreType["BusinessCopyPostalServices"] = 92] = "BusinessCopyPostalServices";
    StoreType[StoreType["DiscountGrocer"] = 93] = "DiscountGrocer";
    StoreType[StoreType["ATM"] = 94] = "ATM";
    StoreType[StoreType["Optical"] = 96] = "Optical";
    StoreType[StoreType["ButcherFishMarket"] = 97] = "ButcherFishMarket";
    StoreType[StoreType["Candles"] = 98] = "Candles";
    StoreType[StoreType["KitchenDiningAccessories"] = 99] = "KitchenDiningAccessories";
    StoreType[StoreType["Legal"] = 100] = "Legal";
    StoreType[StoreType["HealthCare"] = 101] = "HealthCare";
    StoreType[StoreType["SportingGoods"] = 102] = "SportingGoods";
    StoreType[StoreType["MusicVideoGames"] = 103] = "MusicVideoGames";
    StoreType[StoreType["Hobby"] = 104] = "Hobby";
    StoreType[StoreType["GourmetMarket"] = 105] = "GourmetMarket";
    StoreType[StoreType["Cameras"] = 106] = "Cameras";
    StoreType[StoreType["Appliances"] = 107] = "Appliances";
    StoreType[StoreType["MensApparel"] = 109] = "MensApparel";
    StoreType[StoreType["Dance"] = 110] = "Dance";
    StoreType[StoreType["ShoeRepair"] = 111] = "ShoeRepair";
    StoreType[StoreType["Daycare"] = 112] = "Daycare";
    StoreType[StoreType["Cleaners"] = 114] = "Cleaners";
    StoreType[StoreType["Cookies"] = 115] = "Cookies";
    StoreType[StoreType["Pretzels"] = 116] = "Pretzels";
    StoreType[StoreType["SavingsLoan"] = 117] = "SavingsLoan";
    StoreType[StoreType["RealEstate"] = 118] = "RealEstate";
    StoreType[StoreType["NutritionCenter"] = 119] = "NutritionCenter";
    StoreType[StoreType["Restaurant"] = 120] = "Restaurant";
    StoreType[StoreType["RentalShop"] = 121] = "RentalShop";
    StoreType[StoreType["HealthBeautyAids"] = 122] = "HealthBeautyAids";
    StoreType[StoreType["JewelryWatches"] = 124] = "JewelryWatches";
    StoreType[StoreType["EyewareAccessories"] = 125] = "EyewareAccessories";
    StoreType[StoreType["AutoRental"] = 126] = "AutoRental";
    StoreType[StoreType["GardenPatioPool"] = 127] = "GardenPatioPool";
    StoreType[StoreType["CheckCashQuickLoans"] = 128] = "CheckCashQuickLoans";
    StoreType[StoreType["DrinksJuices"] = 129] = "DrinksJuices";
    StoreType[StoreType["DollarVarietyThrift"] = 130] = "DollarVarietyThrift";
    StoreType[StoreType["Marine"] = 131] = "Marine";
    StoreType[StoreType["PawnShop"] = 132] = "PawnShop";
    StoreType[StoreType["TanningSalon"] = 133] = "TanningSalon";
    StoreType[StoreType["AnimalCareGroom"] = 134] = "AnimalCareGroom";
    StoreType[StoreType["FinanceCompany"] = 135] = "FinanceCompany";
    StoreType[StoreType["HotelMotel"] = 136] = "HotelMotel";
    StoreType[StoreType["Pizza"] = 137] = "Pizza";
    StoreType[StoreType["SubSandwich"] = 138] = "SubSandwich";
    StoreType[StoreType["Yogurt"] = 139] = "Yogurt";
    StoreType[StoreType["AutoMaintenanceOilChange"] = 140] = "AutoMaintenanceOilChange";
    StoreType[StoreType["Massage"] = 141] = "Massage";
})(StoreType || (StoreType = {}));
/** CoStar.Api.FusionSearch.Criteria.SubqueryType */
export var SubqueryType;
(function (SubqueryType) {
    SubqueryType[SubqueryType["Add"] = 0] = "Add";
    SubqueryType[SubqueryType["Remove"] = 1] = "Remove";
})(SubqueryType || (SubqueryType = {}));
/** CoStar.Api.FusionSearch.Criteria.SortOrder */
export var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["Ascending"] = 0] = "Ascending";
    SortOrder[SortOrder["Descending"] = 1] = "Descending";
})(SortOrder || (SortOrder = {}));
/** CoStar.Api.FusionSearch.Criteria.ReductionType */
export var ReductionType;
(function (ReductionType) {
    ReductionType[ReductionType["Overpost"] = 0] = "Overpost";
    ReductionType[ReductionType["None"] = 1] = "None";
    ReductionType[ReductionType["ReductionSort"] = 2] = "ReductionSort";
    ReductionType[ReductionType["RetainSort"] = 3] = "RetainSort";
})(ReductionType || (ReductionType = {}));
